<template>
  <div class="w1200">
    <div class="all_categorys">
      <div class="mt">
        <i></i>
        <h3><a href="javascript:void(0);">所有商品分类</a></h3>
      </div>
      <div class="mc">
        <ul class="menu">
          <div v-for="(item, index) in category" :key="index" class="menu-item">
            <li :cat_id="item.id" class="">
              <div class="class">
                <span class="iconfont"></span>
                <h4><a href="javascript:void(0);">{{item.cate_name}}</a></h4>
              </div>
              <div class="sub-class" :cat_menu_id="item.id" style="display: none; top: -2px;">
                <div class="sub-class-content">
                  <div class="recommend-class">
                  </div>
                  <dl v-for="(s_item, s_index) in item.son" :key="s_index">
                    <dt>
                      <h3><a href="javascript:void(0);">{{s_item.cate_name}}</a></h3>
                    </dt>
                    <dd class="goods-class">
                      <router-link v-for="(t_item, t_index) in s_item.son" :key="t_index" :to="{
                              path: '/good/list',
                              query: {
                                id: t_item.id,
                                title: t_item.cate_name,
                                type: 1
                              }
                          }">
                        {{t_item.cate_name}}
                      </router-link>
                    </dd>
                  </dl>
                </div>
                <div class="sub-class-right">
                  <div class="adv-promotions">
                  </div>
                </div>
              </div>
            </li>
          </div>
        </ul>
      </div>
    </div>
    <ul class="site_menu">
      <li>
        <router-link to="/">首页</router-link>
      </li>
      <!-- <li>
        <router-link :to="{
          path: '/shop_street',

        }">店铺街</router-link>
      </li> -->
      <li>
        <router-link :to="{
          path: '/brand',

        }">品牌街</router-link>
      </li>
      <li>
        <router-link :to="{
          path: '/point/shop',

        }">积分商城</router-link>
      </li>
      <li>
        <router-link :to="{
          path: '/seckill/list',

        }">限时秒杀</router-link>
      </li>
      <li>
        <router-link :to="{
          path: '/special/list',

        }">今日特价</router-link>
      </li>
      <li>
        <router-link :to="{
          path: '/discount/list',

        }">限时优惠</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
  import {
    getCategory
  } from '@/api/store';
  export default {
    name: 'ShopNav',

    data() {
      return {
        category: [],
        isGetCategory: false,
      }
    },
    watch: {
      '$route.path': function (newVal, oldVal) {
        var that = this
        if (newVal == '/') {
          this.$nextTick(function () {
            document.getElementsByClassName('mc')[0].style.display = 'block'
          })
        } else {
          this.$nextTick(function () {
            document.getElementsByClassName('mc')[0].style.display = 'none'
          })
        }
      }
    },
    mounted() {
      var that = this;
      if (that.$route.path == '/') {
        document.getElementsByClassName('mc')[0].style.display = 'block'
      } else {
        document.getElementsByClassName('mc')[0].style.display = 'none'
      }
      // if (!localStorage.getItem('category_list')) {
      //   getCategory()
      //     .then((res) => {
      //       that.category = res.data.category_list.slice(0, 15);
      //       localStorage.setItem('category_list', JSON.stringify(that.category))
      //       that.setCategory()
      //     })
      //     .catch((res) => {
      //       that.$dialog.error(res.msg);
      //     });
      // } else {
      //   that.category = JSON.parse(localStorage.getItem('category_list'))
      //   that.setCategory()
      // }
      getCategory()
        .then((res) => {
          that.category = res.data.category_list.slice(0, 15);
          // localStorage.setItem('category_list', JSON.stringify(that.category))
          that.setCategory()
        })
        .catch((res) => {
          that.$dialog.error(res.msg);
        });
    },

    methods: {
      setCategory() {
        var that = this
        this.$nextTick(function () {
          var index = 1;
          $(function () {
            //首页左侧分类菜单
            $(".all_categorys ul.menu").find("li").each(
              function () {
                var addClass = 'category-ico-' + index;
                $(this)
                  .find('span')
                  .addClass(addClass);
                index++;
                $(this).hover(
                  function () {
                    var cat_id = $(this).attr("cat_id");
                    var menu = $(this).find("div[cat_menu_id='" + cat_id + "']");
                    menu.show();
                    $(this).addClass("hover");
                    var menu_height = menu.height();
                    if (menu_height < 60) menu.height(80);
                    menu_height = menu.height();
                    var li_top = $(this).position().top;
                    $(menu).css("top", -li_top + 40);
                  },
                  function () {
                    $(this).removeClass("hover");
                    var cat_id = $(this).attr("cat_id");
                    $(this).find("div[cat_menu_id='" + cat_id + "']").hide();
                  }
                );
              }
            );

            $(".user_menu dl").hover(function () {
              $(this).addClass("hover");
            }, function () {
              $(this).removeClass("hover");
            });

            $('.user_menu .my-mall').mouseover(function () {
              // 最近浏览的商品
              // load_history_information();
              $(this).unbind('mouseover');
            });
            $('.user_menu .my-cart').mouseover(function () {
              // 运行加载购物车
              if (that.is_login) {
                that.getCartList();
              }
              $(this).unbind('mouseover');
            });
            //懒加载
            $("img.lazyload").lazyload({
              effect: "fadeIn",
              skip_invisible: false,
              threshold: 200,
            });
          });
        })
      },

    },

  }
</script>

<style scoped>

</style>
